angular.module('bmsApp.geocode').controller('GeocodeMapCtrl', function ($window,
																		$state,
																		$stateParams,
																		$scope,
																		$q,
																		$filter,
																		notify,
																		CustomerSvc,
																		SiteSvc,
																		EmployeeSvc,
																		BusinessDetailSvc,
																		GeocodeSvc,
																		uiGmapGoogleMapApi) {

	$scope.angular = angular;

	var markerProto = {
		id: 1,
		coords: {
			latitude: 0,
			longitude: 0
		}
	};

	$scope.ctrl = {
		mapType: null,
		mapId: null,
		loading: null,
		defaultCoords: null,
		record: null,
		marker: {
			id: 1 // only using as it's required
		},
		init: function () {
			if ($state.is('main.crm.customer.index.view.geocode')) {
				$scope.ctrl.mapType = 'customer';
				$scope.ctrl.mapId = $stateParams.customerId;
				CustomerSvc.read($scope.ctrl.mapId)
					.then(function (response) {
						$scope.customer = response.data.customer; // for breadcrumb title
					});
			}
			else if ($state.is('main.employee.index.view.geocode')) {
				$scope.ctrl.mapType = 'employee';
				$scope.ctrl.mapId = $stateParams.employeeId;

			}
			else if ($state.is('main.settings.businessDetails.geocode')) {
				$scope.ctrl.mapType = 'business';

			}
			else {
				$scope.ctrl.mapType = 'missing';
			}


			var promises = [uiGmapGoogleMapApi, GeocodeSvc.getDefaultCentre()];
			$q.all(promises)
				.then(function (responses) {
					$scope.ctrl.defaultCoords = {
						latitude: responses[1].data.coords.lat,
						longitude: responses[1].data.coords.lng
					};
					$scope.map = {
						center: angular.copy($scope.ctrl.defaultCoords),
						zoom: 13,
						options: {
							panControlOptions: {
								position: responses[0].ControlPosition.RIGHT_TOP
							},
							zoomControlOptions: {
								position: responses[0].ControlPosition.RIGHT_TOP
							},
							mapTypeControlOptions: {
								position: responses[0].ControlPosition.RIGHT_BOTTOM
							}
						},
						events: {
							click: function (maps, eventName, e) {
								$scope.$apply(function () {
									if ($scope.ctrl.record) {
										$scope.ctrl.marker = angular.copy(markerProto);
										var lat = e[0].latLng.lat();
										var lng = e[0].latLng.lng();
										angular.extend($scope.ctrl.marker.coords, {
											latitude: lat,
											longitude: lng
										});
										$scope.ctrl.record.custom_coord = true;
									}
								});
							}
						}
					};
					$scope.ctrl.loadRecords();
				});
		},
		loadRecords: function () {
			$scope.ctrl.loading = true;
			if ($scope.ctrl.mapType === 'missing') {
				GeocodeSvc.getMissing()
					.then(function (response) {
						$scope.siteCollection = response.data.site_collection;
						$scope.employeeCollection = response.data.employee_collection;
						$scope.businessAddressCollection = response.data.business_address_collection;
						$scope.licenseAddressCollection = response.data.license_address_collection;
						$scope.enquiryCollection = response.data.enquiry_collection;
						$scope.ctrl.loading = false;
					});
			}
			else if ($scope.ctrl.mapType === 'customer') {
				SiteSvc.byCustomer($scope.ctrl.mapId, undefined)
					.then(function (response) {
						$scope.siteCollection = response.data.site_collection;
						$scope.ctrl.loading = false;
					});
			}
			else if ($scope.ctrl.mapType === 'employee') {
				EmployeeSvc.read($scope.ctrl.mapId)
					.then(function (response) {
						$scope.employeeCollection = [response.data.employee];
						$scope.employee = response.data.employee; // for breadcrumb title
						$scope.ctrl.loading = false;
					});
			}
			else if ($scope.ctrl.mapType === 'business') {
				BusinessDetailSvc.read()
					.then(function (response) {
						$scope.businessAddressCollection = [response.data.business];
						$scope.ctrl.loading = false;
					});
			}
			else {
				$scope.ctrl.loading = false;
			}
		},
		recordBlur: function (record) {
			record.selected = false;
			$scope.ctrl.marker = null;
			$scope.ctrl.record = null;
		},
		recordClick: function (record) {
			if (angular.isObject($scope.ctrl.record)) {
				$scope.ctrl.recordBlur($scope.ctrl.record);
			}
			$scope.ctrl.record = record;
			$scope.ctrl.record.selected = true;
			var lat, lng;
			if (angular.isNumber($scope.ctrl.record.lat) && angular.isNumber($scope.ctrl.record.lng)) {
				$scope.ctrl.marker = {
					id: 1,
					coords: {
						latitude: $scope.ctrl.record.lat,
						longitude: $scope.ctrl.record.lng
					},
					options: {},
					events: {}
				};

				$scope.ctrl.centreMarker();
			}
			else {
				$scope.ctrl.marker = null;
			}

		},
		geocodeAddress: function (record, marker) {
			record.custom_coord = false;
			GeocodeSvc.geocodeAddress(record)
				.then(function (response) {
					if (angular.isNumber(response.data.coords.lat) && angular.isNumber(response.data.coords.lng)) {
						if (angular.isObject(marker) !== true) {
							marker = $scope.ctrl.marker = angular.copy(markerProto);
						}
						angular.extend(marker.coords, {
							latitude: response.data.coords.lat,
							longitude: response.data.coords.lng
						});
						$scope.ctrl.centreMarker();
						notify({
							message: 'Address coordinates located successfully'
						});
					}
					else {
						$scope.ctrl.marker = null;
						notify({
							message: 'Failed to locate address coordinates',
							classes: 'warning'
						});
					}
				}, function () {
					notify({
						message: 'Error locating address coordinates',
						classes: 'error'
					});
				});
		},
		recordSave: function (record, marker) {
			record.lat = marker.coords.latitude;
			record.lng = marker.coords.longitude;
			GeocodeSvc.saveRecord(record)
				.then(function (response) {
					$scope.ctrl.recordBlur(response);
					$scope.ctrl.loadRecords();
					notify({
						message: 'Record location data saved successfully'
					});
				}, function () {
					notify({
						message: 'Failed to save location data',
						classes: 'error'
					});
				});
		},
		centreMarker: function () {
			if (angular.isObject($scope.ctrl.marker)) {
				$scope.map.center = angular.copy($scope.ctrl.marker.coords);
			}
		},
		formatLatLng: function (marker) {
			if (angular.isObject(marker)) {
				return $filter('number')(marker.coords.latitude, 8) + ', ' + $filter('number')(marker.coords.longitude, 8);
			}
			else {
				return '';
			}
		},
		back: function () {
			$window.history.back();
		}
	};

	$scope.ctrl.init();

});
